(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sa-accordions"] && !Shopify.designMode) return;
  try {
    
(function(){
  function size(b){ b.style.maxHeight = b.scrollHeight + 'px'; }
  document.querySelectorAll('.sa-acc-head').forEach(function(h){
    if(h.dataset.bound) return; h.dataset.bound='1';
    h.addEventListener('click', function(){
      var acc=h.parentElement, body=acc.querySelector('.sa-acc-body');
      var open=acc.classList.toggle('open');
      body.style.maxHeight = open ? body.scrollHeight+'px' : '0';
    });
  });
  function sizeOpen(){ document.querySelectorAll('.sa-acc.open .sa-acc-body').forEach(size); }
  sizeOpen();
  window.addEventListener('load', sizeOpen);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(sizeOpen);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var main=document.getElementById('saMainImg');
  document.querySelectorAll('.sa-gthumb').forEach(function(b){b.addEventListener('click',function(){if(main)main.src=b.dataset.src;document.querySelectorAll('.sa-gthumb').forEach(function(x){x.classList.remove('active');});b.classList.add('active');});});
  var vid=document.getElementById('saVarId'),pr=document.getElementById('saPrice'),add=document.getElementById('saAdd');
  document.querySelectorAll('.sa-vpill').forEach(function(b){b.addEventListener('click',function(){
    document.querySelectorAll('.sa-vpill').forEach(function(x){x.classList.remove('active');});b.classList.add('active');
    if(vid)vid.value=b.dataset.id; if(pr)pr.textContent=b.dataset.price;
    if(main && b.dataset.img){ main.src=b.dataset.img;
      document.querySelectorAll('.sa-gthumb').forEach(function(x){ x.classList.toggle('active', x.dataset.src===b.dataset.img); }); }
    if(add){ if(b.dataset.available==='false'){add.disabled=true;add.textContent='Sold out';}else{add.disabled=false;add.innerHTML='Add to Cart \u00b7 <span>'+b.dataset.price+'</span>';} }
  });});
  var q=document.getElementById('saQ');
  var m=document.getElementById('saQM'),p=document.getElementById('saQP');
  if(m)m.addEventListener('click',function(){q.value=Math.max(1,(parseInt(q.value)||1)-1);});
  if(p)p.addEventListener('click',function(){q.value=(parseInt(q.value)||1)+1;});
  function size(b){b.style.maxHeight=b.scrollHeight+'px';}
  document.querySelectorAll('.sa-acc-head').forEach(function(h){h.addEventListener('click',function(){var a=h.parentElement,bd=a.querySelector('.sa-acc-body');var o=a.classList.toggle('open');bd.style.maxHeight=o?bd.scrollHeight+'px':'0';});});
  function so(){document.querySelectorAll('.sa-acc.open .sa-acc-body').forEach(size);} so();window.addEventListener('load',so);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(so);
})();

  } catch(e) { console.error(e); }
})();
})();
